var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yandex-pay-widget"})
}
var staticRenderFns = []

export { render, staticRenderFns }